export const lightThemeShadows = {
    xs: '0px 1px 2px rgba(16, 24, 40, 0.05)',
    sm: '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
    md: '0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)',
    lg: '0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)',
    xl: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
    xl2: '0px 24px 48px -12px rgba(16, 24, 40, 0.18)',
    xl3: '0px 32px 64px -12px rgba(16, 24, 40, 0.14)',
    right_shadow: '9px 0px 54px 0px rgba(0, 0, 0, 0.08), 0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)',
};
export const darkThemeShadows = {
    xs: '0px 1px 2px 0px rgba(0, 0, 0, 0.15)',
    sm: '0px 1px 2px 0px rgba(0, 0, 0, 0.26), 0px 1px 3px 0px rgba(0, 0, 0, 0.20)',
    md: '0px 2px 4px -2px rgba(0, 0, 0, 0.36), 0px 4px 8px -2px rgba(0, 0, 0, 0.20)',
    lg: '0px 4px 6px -2px rgba(0, 0, 0, 0.33), 0px 12px 16px -4px rgba(0, 0, 0, 0.18)',
    xl: '0px 8px 8px -4px rgba(0, 0, 0, 0.13), 0px 20px 24px -4px rgba(0, 0, 0, 0.30)',
    xl2: '0px 24px 48px -12px rgba(0, 0, 0, 0.50)',
    xl3: '0px 32px 64px -12px rgba(0, 0, 0, 0.70)',
    right_shadow: '9px 0px 54px 0px rgba(0, 0, 0, 0.08), 0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)',
};
//# sourceMappingURL=shadows.js.map